import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

export type PortalModalShellSize = 'sm' | 'md' | 'lg' | 'xl';

/**
 * Dark-chrome modal chrome: overlay, navy header, body/footer projection.
 * Use for page-local *ngIf dialogs or as the visual root of NgbModal content.
 */
@Component({
  selector: 'app-portal-modal-shell',
  templateUrl: './portal-modal-shell.component.html',
  styleUrls: ['./portal-modal-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortalModalShellComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() size: PortalModalShellSize = 'md';
  @Input() busy = false;
  @Input() dismissible = true;
  @Input() showClose = true;
  @Input() closeAriaLabel = '';
  /** When false, only the dialog is rendered (NgbModal already supplies backdrop). */
  @Input() showOverlay = true;

  @Output() dismiss = new EventEmitter<void>();

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent): void {
    if (!this.dismissible || this.busy) return;
    event.preventDefault();
    this.dismiss.emit();
  }

  onOverlayClick(): void {
    if (!this.dismissible || this.busy || !this.showOverlay) return;
    this.dismiss.emit();
  }

  onCloseClick(): void {
    if (!this.dismissible || this.busy) return;
    this.dismiss.emit();
  }
}
